import React from "react";
import Night from "../../assets/icons/dark_mode.svg";
import Sunny from "../../assets/icons/sunny.svg";

export default function LG({ isDarkMode, setIsDarkMode }) {
  return (
    // <div className="w-8 flex justify-center items-center">
      <button
        onClick={() => setIsDarkMode(!isDarkMode)}
        className={`dark:text-white w-9 h-full flex justify-center items-center`}
      >
        <img className=""
          src={isDarkMode ? Sunny : Night }
          alt={isDarkMode ? "Sunny" : "Night"}
        />
      </button>
    // </div>
  );
}
